import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/base/Button';
import DemoModal from '../../../components/feature/DemoModal';

export default function CTASection() {
  const { t } = useTranslation();
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
  
  const scrollToSolutions = () => {
    const solutionsSection = document.getElementById('solutions');
    if (solutionsSection) {
      solutionsSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <>
      <section id="contact" className="py-20 bg-gray-900 text-white relative overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px'
          }}></div>
        </div>
        
        <div className="container mx-auto px-6 text-center relative z-10">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            {t('cta.title')}
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-8 leading-relaxed">
            {t('cta.subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button variant="primary" size="lg" className="min-w-48 bg-emerald-600 hover:bg-emerald-700" onClick={scrollToSolutions}>
              {t('cta.exploreSolutions')}
            </Button>
            <Button 
              variant="outline" 
              size="lg" 
              className="min-w-48 border-white text-white hover:bg-white hover:text-gray-900"
              onClick={() => setIsDemoModalOpen(true)}
            >
              {t('cta.scheduleDemo')}
            </Button>
          </div>
          
          {/* Contact Info */}
          <div className="mt-16 flex flex-col md:flex-row justify-center items-center gap-8 text-gray-300">
            <div className="flex items-center">
              <i className="ri-mail-line text-emerald-400 mr-2"></i>
              <span>info@aich.ai</span>
            </div>
            <div className="flex items-center">
              <i className="ri-phone-line text-emerald-400 mr-2"></i>
              <span>+1 (555) 123-4567</span>
            </div>
            <div className="flex items-center">
              <i className="ri-map-pin-line text-emerald-400 mr-2"></i>
              <span>United States</span>
            </div>
          </div>
        </div>
      </section>

      <DemoModal isOpen={isDemoModalOpen} onClose={() => setIsDemoModalOpen(false)} />
    </>
  );
}
